import { TemplateData, TemplateParams } from '.';

const supervisorSummary = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{myTeamUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        {{summaryContent}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.supervisorSummaryEmail}`
  },
  placeholders: {
    myTeamUrl: {
      label: messages.myTeamPageLink,
      value: `${serverConfig.adminUrl}/my-team`
    },
    summaryContent: {
      label: messages.emailSummaryOfNewEvents
    },
    ...defaultPlaceholders
  },
  title: messages.supervisorSummaryEmail
});

export default supervisorSummary;
